"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const logger_1 = require("../utils/logger");
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const styles = (0, tailwind_1.default)({
    button: `
    tw-rounded
    tw-px-2
    tw-py-1
    tw-font-medium`,
});
function Button(_a) {
    var { as, className, style } = _a, props = __rest(_a, ["as", "className", "style"]);
    const theme = (0, use_theme_1.default)();
    const Component = as;
    if (process.env.NODE_ENV !== 'production') {
        if (as !== 'a' && props.href) {
            (0, logger_1.getApplicationLogger)().warn('[a11y]', "Potential accessibility error. Got an href on an element which isn't an <a />");
        }
    }
    return (react_1.default.createElement(Component, Object.assign({ className: `${styles.button} ${className || ''}`, style: Object.assign({ color: theme.primary, background: theme.secondary }, style) }, props)));
}
exports.default = Button;
//# sourceMappingURL=button.js.map